import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { MenuItem } from '../../../components/Menu/MenuItem'

import { logout } from '../../Login/actions'
import messages from './messages';

function LogoutButton({ logout }) {
  return (
    <FormattedMessage {...messages.logoutButton}>
      { message => (
        <MenuItem
          type='button'
          // title={message}
          title={`${message}\rLos datos de tu solicitud están guardados por el plazo de un mes`}
          onClick={logout}
        >
          {message}
        </MenuItem>
      )}
    </FormattedMessage>
  )
}

LogoutButton.propTypes = {
  logout: PropTypes.func.isRequired,
}

const mapDispatchToProps = { logout }
const connector = connect(null, mapDispatchToProps)

export default connector(LogoutButton)
